import { ActionMenu } from 'components/ActionStyles/ActionStyles'
import RightArrow from 'components/icons/RightArrow'
import React from 'react'
import { COLORS } from 'theme'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import {
  CandCount,
  CardSectionFlex,
  CardText,
  CardsDiv,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
  RoleFlex,
  RoleNumber,
  RoleTitle,
} from './style'

export const roleMenu = (onRoleChange, roleMenu = []) => (
  <ActionMenu
    width="335px"
    items={
      Array.isArray(roleMenu)
        ? roleMenu?.map((role, index) => {
            return {
              key: index,
              label: (
                <RoleFlex
                  row
                  spaceBetween
                  centerVertically
                  onClick={() => onRoleChange(role?.roleId)}
                >
                  <RoleFlex column>
                    <RoleNumber>Role {getZeroBeforeInt(index + 1)}</RoleNumber>
                    <RoleTitle>{role?.roleName}</RoleTitle>
                  </RoleFlex>
                  <CandCount>
                    {getZeroBeforeInt(role?.candidateCount)}
                  </CandCount>{' '}
                </RoleFlex>
              ),
            }
          })
        : Object.keys(roleMenu)
    }
  />
)

const DriveRoleMetrics = ({
  rolesMetrics,
  selectedRound,
  setSelectedRound,
  setSearchParams,
  setCurrentPage,
  setSelectedCandidateId,
  setSelectedCandidate,
  setCurrentTab,
  setStatus,
  setFilterStatus,

  checkType,

  setPanelData,
  setPanelValue,
  setSearchBy,
  setFilterSearchText,
  setSelectAll,
  publshedBy,
  setMultiSelect,
  setState,
  setCheckStatus,
  setWholeSelect,
  setCheckGender,
  setCheckSkills,
  setCheckYear,
  setScoreEntries,
  setCheckArrears,
  setCheckLocation,
}) => {
  const onClickRound = (round, type, assessment, extAssmnts, index) => {
    setCurrentPage(0)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setCurrentTab('ACTIVE')
    setStatus('ACTIVE')
    setFilterStatus('ACTIVE')
    setSelectedRound(round)
    let paramerters = {
      stage: round,
      type: type ?? 'all',
      jobType: checkType,
      publishedBy: publshedBy,
    }
    if (index != undefined) {
      paramerters.stageindex = index
    }
    setSearchParams(paramerters)
    setPanelData('')
    setPanelValue('all')
    setSearchBy('')
    setFilterSearchText(false)
    setSelectAll(false)
    setMultiSelect([])
    setState({
      degreeValue: [],
      degreeList: [],
      selectedCourse: [],
      departList: [],
      departValue: [],
      selectedDepartCourse: [],
      splValue: [],
      splList: [],
      selectedSplCourse: [],
    })
    setCheckStatus([])
    setCheckGender([])
    setCheckSkills([])
    setCheckYear([])
    setScoreEntries([])
    setCheckArrears([])
    setCheckLocation([])
    setWholeSelect(false)
  }

  return (
    <div>
      <CardsRowFlex row wrap>
        <CardsDiv noBorder={rolesMetrics?.rounds?.length === 0}>
          <CardsFlex
            column
            onClick={() => onClickRound('all_candidates')}
            isSelected={selectedRound === 'all_candidates'}
          >
            <CardText>All Candidates</CardText>
            <CardsValue>
              {getZeroBeforeInt(rolesMetrics?.candidateCount)}
            </CardsValue>
          </CardsFlex>
        </CardsDiv>

        {rolesMetrics?.rounds?.map((round, index) => (
          <CardSectionFlex key={index + round?.name} centerVertically>
            <CardsFlex
              column
              onClick={() =>
                onClickRound(
                  round?.name,
                  round?.type,
                  round?.assesmentType,
                  round?.extAssmnts,
                  index
                )
              }
              isSelected={selectedRound === round?.name}
            >
              <CardText>
                {round?.name == 'offer' ? 'Intent to offer' : round?.name}
              </CardText>
              <CardsValue>{getZeroBeforeInt(round?.count)}</CardsValue>
            </CardsFlex>
            {rolesMetrics?.rounds?.length - 1 !== index && (
              <RightArrow color={COLORS.GREY_T_80} />
            )}
          </CardSectionFlex>
        ))}
      </CardsRowFlex>
    </div>
  )
}

export default DriveRoleMetrics
